
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_45685","data-name":"Group 45685","transform":"translate(-1229 -1282)"}},[_c('rect',{attrs:{"id":"Rectangle_15303","data-name":"Rectangle 15303","width":"30","height":"30","transform":"translate(1229 1282)","fill":"none"}}),_c('path',{attrs:{"id":"Path_32712","data-name":"Path 32712","d":"M5.25 21.75A.75.75 0 014.5 21V9a2.253 2.253 0 012.25-2.25h16.5a.75.75 0 010 1.5H6.75A.752.752 0 006 9v12a.75.75 0 01-.75.75","transform":"translate(1229 1282)","fill":"#5555f2"}}),_c('path',{attrs:{"id":"Path_32713","data-name":"Path 32713","d":"M26.255 9.75h-16.5A2.253 2.253 0 007.505 12v12a2.253 2.253 0 002.25 2.25h16.5A2.253 2.253 0 0028.5 24V12a2.252 2.252 0 00-2.245-2.25m-6 5.63a1.125 1.125 0 111.125-1.125 1.125 1.125 0 01-1.125 1.125M9.005 24v-1.94l4.93-4.94a1.521 1.521 0 012.13 0l5.16 5.16a.75.75 0 001.06-1.06l-.97-.97.87-.88a1.521 1.521 0 012.13 0L27 22.06V24a.755.755 0 01-.75.75H9.755a.755.755 0 01-.75-.75","transform":"translate(1229 1282)","fill":"#5555f2"}}),_c('rect',{attrs:{"id":"Rectangle_15304","data-name":"Rectangle 15304","width":"24.005","height":"19.497","transform":"translate(1233.5 1288.75)","fill":"none"}})])])
          )
        }
      }
    